import React from 'react';

const CpdProgressBar = ({ currentHours, requiredHours, cycleYears }) => {
    const percentage = Math.min((currentHours / requiredHours) * 100, 100);

    // MODIFICATION: Create a dynamic title based on the cycle length
    const getTitle = () => {
        if (!cycleYears || cycleYears === 1) {
            return "Annual CPD Progress";
        }
        if (cycleYears === 2) {
            return "Biennial CPD Progress";
        }
        if (cycleYears === 3) {
            return "Triennial CPD Progress";
        }
        return `CPD Progress (${cycleYears} Year Cycle)`;
    };

    return (
        <div className="bg-gray-100 dark:bg-gray-800 p-6 rounded-xl shadow-lg border border-gray-300 dark:border-gray-700">
            <div className="flex justify-between items-center mb-2">
                <h3 className="text-lg font-bold text-blue-800 dark:text-blue-300">
                    {getTitle()}
                </h3>
                <span className="text-lg font-semibold text-gray-800 dark:text-gray-200">
                    {currentHours.toFixed(1)} / {requiredHours} hours
                </span>
            </div>
            <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-4">
                <div
                    className="bg-blue-600 h-4 rounded-full transition-all duration-500 ease-out"
                    style={{ width: `${percentage}%` }}
                ></div>
            </div>
            <p className="text-center text-sm text-gray-600 dark:text-gray-400 mt-2">
                You've completed {percentage.toFixed(0)}% of your requirement for this cycle.
            </p>
        </div>
    );
};

export default CpdProgressBar;